export const LocalesList = ["en", "da", "de", "fr", "ro", "uk", "be", "nl"] as const;

export type LocaleType = (typeof LocalesList)[number];

export type LocaleMap<T> = {
  [key in LocaleType]: T;
};
